import { StopPropagationDirective } from './directives/stop-propagation.directive';

export { StopPropagationDirective } from './directives/stop-propagation.directive';

export const DIRECTIVES: any[] = [
	StopPropagationDirective,
];
